export default "__VITE_ASSET__CePtXIZV__"